import { useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import Datepicker from "../components/Form/Datepicker";

export default function Intro() {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex justify-end items-center">
                <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                    <Progressbar percentage={"0"} />
                </div>
            </div>
            <Box>

                <h2>Innan du börjar</h2>

                <ul>
                    <li>
                        Se till att du har kvitton om du behövt åka taxi (bild räcker).
                    </li>
                    <li>
                        Har du rest med Resplusbiljett? Ansök om <a target="_blank" href="https://forseningsersattning.resplus.se/?id=253">förseningsersättning hos Samtrafiken.</a>
                    </li>
                    <li>
                        Har du rest med färdtjänst eller sjukresa? <a target="_blank" href="https://www.ostgotatrafiken.se/sa-reser-du-med-oss/bestallningstrafik/fardtjanst--sjukresor/forseningsersattning-fardtjanst/">Ansök om förseningsersättning för färdtjänst och sjukresa här</a>.
                    </li>
                    <li>Har du rest med Krösatåg över länsgränsen? Ansök om <a target="_blank" href="https://kalmarlanstrafik.se/Kundservice/ansok-forseningsersattning-eller-aterbetalningreklamation/">förseningsersättning hos Kalmar länstrafik.</a></li>
                </ul>
                <p>
                    Om du stöter på frågor längs vägen är du välkommen att höra av dig till kundservice.
                </p>
            </Box>

            <div className="flex justify-center">
                <div className="w-full text-right">
                    <button
                        onClick={() => navigate("/hur-du-reste")}
                        className="btn primary"
                        type="submit"
                    >
                        Börja ansöka
                    </button>
                </div>
            </div>
        </div>
    );
}
